const columnVisibilityModel = {
  patientName: true,
  subjectId: true,
  studyName: true,
  siteName: true,
  statusCode: true,
  cardType: false,
  pcn: false,
  patientId: false,
  creationDate: true
};

export const initialState = {
  sorting: {
    sortModel: [{ field: 'patientName', sort: 'asc' }]
  },
  columns: {
    columnVisibilityModel
  }
};
